// ⚠️注意：本文件内的逻辑请在服务端实现，本Demo只展示用
import axios from 'axios';
import md5 from 'md5';

// 获取 ClientToken
// 详细说明见 https://developer.open-douyin.com/docs/resource/zh-CN/dop/develop/openapi/account-permission/client-token
const getClientToken = async () => {
  const { data } = await axios.post('https://dy.zzhaowai.cn/prod-api/douyin/getClientToken');
  return data.data;
};

// 获取 Ticket
// 详细说明见 https://developer.open-douyin.com/docs/resource/zh-CN/dop/develop/openapi/tools-ability/jsb-management/get-jsb-ticket/
const getTicket = async () => {
  const { data } = await axios.get('https://dy.zzhaowai.cn/prod-api/douyin/getJsbTicket');
  return data.data;
};

// 计算签名
// 将从服务端获取到的 ticket，随机字串 noncestr，时间戳 timestamp和当前页面url，排序后进行md5加密生成签名
// 详细说明见 https://developer.open-douyin.com/docs/resource/zh-CN/dop/develop/sdk/web-app/js/signature
const calcSignature = ({ ticket, nonce_str, timestamp, url }) => {
  const str = `jsapi_ticket=${ticket}&nonce_str=${nonce_str}&timestamp=${timestamp}&url=${url}`;
  const sig = md5(str);
  return sig;
};

// 先获取 Client Token，然后通过 Token 获取 JS Ticket
// 详细说明见 https://developer.open-douyin.com/docs/resource/zh-CN/dop/develop/sdk/web-app/js/permission
export const getConfigParams = async ({ timestamp, nonce_str, url }) => {
  const client_key = 'awsadg4cpf5txxk3'; // clientKey在你的网页应用申请通过后得到
  const client_secret = ''; // clientSecret在你的网页应用申请通过后得到
  const access_token = await getClientToken();
  const ticket = await getTicket();
  const signature = await calcSignature({ ticket, timestamp, nonce_str, url });
  return { client_key, signature };
};
